import { setAppErrorToast, setAppSuccessToast } from '../../store/user/user.actions';
import { HTTP, rootApi, SuccessResponse } from '../index';
import { userApi } from '../user';

export const xeroApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    xeroDisconnect: builder.mutation<SuccessResponse, void>({
      query(body) {
        return {
          url: `/xero/disconnect`,
          method: HTTP.PATCH,
          body,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data?.success) {
          dispatch(setAppSuccessToast(data?.message));
          dispatch(userApi.endpoints.me.initiate(undefined, { forceRefetch: true }));
        } else {
          dispatch(setAppErrorToast(data?.message));
        }
      },
    }),
    qbDisconnect: builder.mutation<SuccessResponse, void>({
      query(body) {
        return {
          url: `/quick_books/disconnect`,
          method: HTTP.PATCH,
          body,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data?.success) {
          dispatch(setAppSuccessToast(data?.message));
          dispatch(userApi.endpoints.me.initiate(undefined, { forceRefetch: true }));
        } else {
          dispatch(setAppErrorToast(data?.message));
        }
      },
    }),
  }),

  overrideExisting: true,
});

export const {
  useXeroDisconnectMutation,
  useQbDisconnectMutation,
} = xeroApi;
